export default class RmSwitch {
    constructor($timeout) {
        return {
            restrict: 'E',
            scope: {
                model: '=',
                onText: '=',
                offText: '=',
                trueValue: '@',
                falseValue: '@',
                callback: '&'
            },
            template: require("../../../../views/directives/rm-switch.html"),
            controller: ['$scope', '$timeout', ($scope, $timeout) => {
                // Make sure angular digest triggers on change.
                $scope.applyChange = function () {
                    $timeout(() => {
                        $scope.$apply();
                        
                        if ($scope.callback) {
                            $scope.callback();
                        }
                    });
                };
            }]
        }
    }
};
